import { useState, useEffect } from "react";
import {
  employeeExperienceTranslate,
  modalAssignTranslate,
  wheelCollaboratorTranslate,
} from "../../i18n/translatedMessages";
import { personalInfoTranslate } from "../../i18n/translatedMessages";
import { FormattedMessage } from "react-intl";
import { SalarioIcon } from "../../Icons/CollaboratorsIcons";
import { contractTypesList } from "../../API/Employee/Profile";
import { getSalaryCandidate, patchSalaryCandidate } from "../../API/Candidates/Salary";
import Loading from "../../Components/Loading/Loading";
import Swal from "sweetalert2";

const InfoSalario = () => {
  const REGEXNumber = /^\$?(([1-9](\d*|\d{0,2}(,\d{3})*))|0)(.\d{1,2})?$/g;
  const [salaryInfoCandidate, setSalaryInfoCandidate] = useState();
  const [contractList, setContractList] = useState([]);

  const [date, setDate] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const asyncRequests = async () => {
      setContractList(await contractTypesList());
      const salaryCandidate = await getSalaryCandidate(localStorage.getItem("candidateId"));
      if (salaryCandidate.items) {
        setSalaryInfoCandidate(salaryCandidate.items);
        const inputDate = salaryCandidate.items?.last_adjustment;
        if (inputDate) {
          const turnDate = new Date(inputDate).toISOString().split("T")[0];
          setDate(turnDate);
        }
        setLoading(false);
      } else {
        setLoading(false);
      }
    };
    asyncRequests();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setSalaryInfoCandidate((salaryInfoCandidate) => ({
      ...salaryInfoCandidate,
      [name]: value,
    }));
    if (name === "last_adjustment") {
      setDate(value);
    }
  };

  const handleSend = async (event, id) => {
    const resp = await patchSalaryCandidate(
      localStorage.getItem("candidateId"),
      salaryInfoCandidate
    );
    if (resp.status === 200) {
      Swal.fire({
        title: "El envío se ha efectuado con exito!",
        text: "",
        icon: "success",
        showCancelButton: false,
        showConfirmButton: true,
      });
    } else {
      Swal.fire({
        title: "Hola 👋",
        text: "Algo ha ido mal, inténtalo más tarde!",
        icon: "info",
        confirmButtonText: "Ok",
      });
    }
  };

  const currency = (e) => {
    let { name, value } = e.target;
    // let value = e.target.value;
    value = value.replace(/\D/g, "");
    value = value.replace(/(\d)(\d{2})$/g, "$1,$2");
    value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");

    e.target.value = value;
    setSalaryInfoCandidate((salaryInfoCandidate) => ({
      ...salaryInfoCandidate,
      [name]: value,
    }));
    return e;
  };
  // useEffect(() => {
  //   setSalaryInfoCandidate({
  //     ...salaryInfoCandidate,
  //     ["fixed_value"]: e.target.value,
  //   })
  // }, [salaryInfoCandidate?.fixed_value]);

  return (
    <div className="">
      <div className="row mb-4 sideMenuSeparator align-items-center">
        <div className="col-2">
          <span className="title-icon p-2 m-auto">
            <SalarioIcon size={20} />
          </span>
        </div>
        <div className="col-10">
          <h1>{wheelCollaboratorTranslate.salary}</h1>
          <p className="description-section">{personalInfoTranslate.salaryDesc}</p>
        </div>
      </div>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="row">
            <div className="col-md-6 col-lg-6 col-xl-4">
              <label htmlFor="employeeSalary" className="form-label mt-2">
                {personalInfoTranslate.personalFixBruteSalary}
              </label>
              <input
                className="form-control text-center m-0"
                name="fixed_value"
                type="text"
                pattern={REGEXNumber}
                aria-label="salario"
                value={salaryInfoCandidate?.fixed_value}
                onChange={(e) => currency(e)}
              />
            </div>
            <div className="col-md-6 col-lg-6 col-xl-4">
              <label htmlFor="employeeTypeCurrency" className="form-label mt-2">
                {personalInfoTranslate.personalCoin}
              </label>
              <select
                className="form-select rounded-pill m-0"
                aria-label="Default select example"
                name="currency"
                value={salaryInfoCandidate?.currency}
                onChange={(e) => handleChange(e)}
              >
                <FormattedMessage id="selectOption0">
                  {(msg) => <option>{msg}</option>}
                </FormattedMessage>
                <option value="AR$">AR$</option>
                <option value="CLP">CLP</option>
                <option value="COP">COP</option>
                <option value="MEX">MEX</option>
                <option value="R$">R$</option>
                <option value="S/.">S/.</option>
                <option value="USD">USD</option>
              </select>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-4">
              <label htmlFor="" className="form-label mt-2">
                {personalInfoTranslate.personalVariableSalary}
              </label>
              <select
                className="form-select  rounded-pill m-0"
                aria-label="Default select example"
                name="variable_salary"
                value={salaryInfoCandidate?.variable_salary}
                onChange={(e) => handleChange(e)}
              >
                {Array.from({ length: 20 }).map((_, index) => {
                  return (
                    <option key={index} value={index / 2 + 0.5}>
                      {index / 2 + 0.5}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-4">
              <label htmlFor="lastAdjustDate" className="form-label mt-2">
                {personalInfoTranslate.lastSalaryAdjust}:
              </label>
              <input
                type="date"
                id="lastAdjustDate"
                name="last_adjustment"
                className="form-control rounded-pill"
                value={date || ""}
                onChange={(e) => handleChange(e)}
              />
            </div>

            <div className="col-md-6 col-lg-6 col-xl-4">
              <label htmlFor="" className="form-label mt-2">
                {employeeExperienceTranslate.contractTypeEE}
              </label>
              <select
                className="form-select rounded-pill m-0"
                aria-label="Default select example"
                name="contract_type"
                value={salaryInfoCandidate?.contract_type || contractList[0]?.id}
                onChange={(e) => handleChange(e)}
              >
                <option value={null}>Seleccionar</option>
                {contractList?.map((contract, index) => {
                  return (
                    <option key={index} value={contract.type}>
                      {contract.type}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-4">
              <label htmlFor="salary_claim" className="form-label mt-2">
                {personalInfoTranslate.salaryExpectation}
              </label>
              <input
                id="salary_claim"
                className="form-control text-center m-0"
                name="salary_claim"
                type="text"
                pattern={REGEXNumber}
                aria-label="salario"
                value={salaryInfoCandidate?.salary_claim}
                onChange={(e) => currency(e)}
              />
            </div>
          </div>
          <div className="row  mt-4 ">
            <div className="col-md-12 col-lg-12 col-xl-12 d-flex align-items-end">
              <button
                className="btn rounded-pill btn-moveStep"
                data-salid={localStorage.getItem("candidateId")}
                onClick={(e) => handleSend(e, localStorage.getItem("candidateId"))}
              >
                {modalAssignTranslate.btnSave}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default InfoSalario;
